import {Paper} from "@mui/material";
import React from "react";
import Carousel from "react-material-ui-carousel";
import Box from "@mui/material/Box";
import {
    bannerActiveIndicatorIconSx,
    bannerIndicatorIconSx,
    bannerNavButtonSx,
    CAROUSEL_NAV_ICON_COLOR,
    CAROUSEL_TRANSITION_MS,
    CarouselNavIcon,
} from "./carouselNavShared";

const BANNER_CAROUSEL_HEIGHT = 584;
const BANNER_IMAGE_HEIGHT = 576;
const BANNER_INDICATORS_HEIGHT = 8;

const bannerCarouselSx = {
    height: `${BANNER_CAROUSEL_HEIGHT}px`,
    minWidth: "1620px",
    "@media (max-width: 1620px)": {
        minWidth: "1450px",
    },
    "@media (max-width: 1500px)": {
        minWidth: "693px",
    },
};

const bannerContainerSx = {
    width: "100%",
    minHeight: `${BANNER_CAROUSEL_HEIGHT + BANNER_INDICATORS_HEIGHT}px`,
};

const bannerImageSx = {
    height: `${BANNER_IMAGE_HEIGHT}px`,
    width: "801px",
    borderRadius: "8px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "@media (max-width: 850px)": {
        width: "693px",
    },
};

const bannerSlideSx = {
    display: "flex",
    justifyContent: "center",
    boxShadow: "none",
    gap: "16px",
};

const BannerPlaceholder = () => (
    <Box
        sx={{
            height: `${BANNER_CAROUSEL_HEIGHT}px`,
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "16px",
            ...bannerCarouselSx,
            minWidth: "unset",
        }}
    >
        <Box
            sx={{
                ...bannerImageSx,
                backgroundColor: (theme) => theme.palette.background.grey,
            }}
        />
        <Box
            sx={{
                ...bannerImageSx,
                backgroundColor: (theme) => theme.palette.background.grey,
                "@media (max-width: 1500px)": {
                    display: "none",
                },
            }}
        />
    </Box>
);

export const UpMeBannerCarousel = ({banners = [], autoPlay = true}) => {
    const slides = Array.isArray(banners) ? banners : [];
    const carouselNavIconSx = {
        width: "14px",
        height: "21px",
        "& path": {
            stroke: CAROUSEL_NAV_ICON_COLOR,
        },
    };

    return (
        <Box sx={bannerContainerSx}>
            {slides.length === 0 ? (
                <BannerPlaceholder/>
            ) : (
            <Carousel
                height={`${BANNER_CAROUSEL_HEIGHT}px`}
                sx={bannerCarouselSx}
                animation="slide"
                autoPlay={autoPlay}
                swipe
                interval={10000}
                duration={CAROUSEL_TRANSITION_MS}
                navButtonsAlwaysVisible={false}
                indicators
                NextIcon={<CarouselNavIcon rotate="rotate(180deg)" iconSx={carouselNavIconSx}/>}
                PrevIcon={<CarouselNavIcon iconSx={carouselNavIconSx}/>}
                navButtonsProps={{sx: bannerNavButtonSx}}
                navButtonsWrapperProps={{sx: {display: "none"}}}
                indicatorIconButtonProps={{sx: bannerIndicatorIconSx}}
                activeIndicatorIconButtonProps={{sx: bannerActiveIndicatorIconSx}}
                indicatorContainerProps={{
                    style: {
                        marginTop: "4px",
                        display: "flex",
                        justifyContent: "center",
                        gridGap: "2px",
                    },
                }}
            >
                {slides.map((item, i) => {
                    const item2 = i === slides.length - 1 ? slides[0] : slides[i + 1];

                    return (
                        <Paper key={item.id} sx={bannerSlideSx}>
                            <Box
                                sx={{
                                    ...bannerImageSx,
                                    backgroundImage: `url(${item.relativeUrl || item?.pictures[0]?.relativeUrl})`,
                                }}
                            />
                            <Box
                                sx={{
                                    ...bannerImageSx,
                                    backgroundImage: `url(${item2.relativeUrl || item2?.pictures[0]?.relativeUrl})`,
                                    "@media (max-width: 1500px)": {
                                        display: "none",
                                    },
                                }}
                            />
                        </Paper>
                    );
                })}
            </Carousel>
            )}
        </Box>
    );
};

export default UpMeBannerCarousel;
